import { Action } from '@ngrx/store';

import { ContainerIdentifierWithIndex } from '®shared/container-structure';

export enum SectionHoverBarActionTypes {
  UPDATE_HIGHLIGHTED_SECTION_HOVER_BAR = '[Section hover bar] Update highlighted section hover bar',
}

export interface HighlightSectionHoverBarPayload {
  highlighted: ContainerIdentifierWithIndex | null;
}

export class UpdateHighlightedSectionHoverBarAction implements Action {
  readonly type =
    SectionHoverBarActionTypes.UPDATE_HIGHLIGHTED_SECTION_HOVER_BAR;

  constructor(public payload: HighlightSectionHoverBarPayload) {}
}

export type SectionHoverBarActions = UpdateHighlightedSectionHoverBarAction;
